import React from "react";
import { Wrench, Sparkles, Coffee, Stethoscope, Home, GraduationCap } from "lucide-react";
import Reveal from "./Reveal";

const NICHES = [
    { icon: Wrench, label: "Майстри та ремонт" },
    { icon: Sparkles, label: "Краса та здоров'я" },
    { icon: Coffee, label: "Кафе та ресторани" },
    { icon: Stethoscope, label: "Медицина та стоматологія" },
    { icon: Home, label: "Нерухомість та дизайн" },
    { icon: GraduationCap, label: "Навчання та курси" },
];

export const ForWhom = () => {
    return (
        <section className="section" data-testid="for-whom-section">
            <div className="container-mx">
                <Reveal>
                    <h2 className="font-display font-extrabold text-text-primary max-w-[820px]" style={{ fontSize: "clamp(28px, 4vw, 44px)", letterSpacing: "-0.02em" }}>
                        AutoAds для тих хто <span className="text-primary-c">займається бізнесом</span>,
                        не рекламою
                    </h2>
                    <p className="mt-4 text-lg text-secondary-c max-w-[640px]">
                        Якщо ви власник — ваш час коштує дорожче ніж вивчення Google Ads
                    </p>
                </Reveal>

                <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
                    {NICHES.map((n, i) => {
                        const Icon = n.icon;
                        return (
                            <Reveal key={i} delay={i * 0.06}>
                                <div
                                    data-testid={`niche-${i}`}
                                    className="glass glass-hover rounded-xl p-6 flex items-center gap-4"
                                >
                                    <div className="w-11 h-11 rounded-lg flex items-center justify-center shrink-0" style={{ background: "rgba(109,94,248,0.1)" }}>
                                        <Icon size={20} className="text-primary-c" />
                                    </div>
                                    <span className="font-medium text-text-primary text-base">{n.label}</span>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>

                <Reveal delay={0.3}>
                    <p className="mt-8 italic text-sm text-secondary-c text-center">
                        І будь-який інший локальний бізнес якому потрібні клієнти з Google
                    </p>
                </Reveal>
            </div>
        </section>
    );
};

export default ForWhom;
